import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { getConfigMsg, getOnBoardingAPIStatus, getOnBoardingStatus } from "../slices/onBoardingSlice";
import { setUserInfo } from "../slices/userProfileSlice";
import KRouter from "./KRouter";
import keycloak from "./keycloak";
import AppHeader from "src/components/Header/AppHeader";
import { SidebarLayout } from "@scuf/common";
import SideBarApp from "./../components/sidebar/sidebar";

export const GetUserDetails = () => {
  const { keycloak }: any = useKeycloak();
  const userDetails: any = {};
  if (!!keycloak && keycloak.token) {
    userDetails['token'] = keycloak?.token;
    //   userDetails['idToken'] = keycloak?.idToken;
    sessionStorage.setItem("token", keycloak?.token);
    sessionStorage.setItem("idToken", keycloak?.idToken);
  }
  return userDetails;
}

const KeyCloackAuth = (props: any) => {
  const { initialized, keycloak }: any = useKeycloak();
  const isLoggedIn = keycloak.authenticated;
  const dispatch = useDispatch();
  const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
  const userDetails: any = GetUserDetails();

  useEffect(() => {
    if (isLoggedIn) {

      if (!keycloak.userInfo)
        keycloak.loadUserInfo().then((user: any) => {
          dispatch(setUserInfo({
            "user_img_url": '',
            "email": user.email,
            "family_name": user.family_name,
            "given_name": user.given_name,
            "name": user.name,
            "eid": user.sub,
            sub: user.sub
          }));
        });
      if (userOnboardAPIStatus === 'idle') {
        dispatch(getOnBoardingStatus());
      }


    }
  }, [isLoggedIn]);
  return (

    <KRouter userDetails={userDetails} initialized={initialized} keycloak={keycloak} />

  );
};

export const KeyCloackAuthProvider = () => {
  useSelector(getConfigMsg);
  const [isSideBarClosed, toggleSideBar] = useState(true);

  return (
    <ReactKeycloakProvider authClient={keycloak} onTokens={({ token, idToken }) => { sessionStorage.setItem("token", token ? token : ''); sessionStorage.setItem("idToken", idToken ? idToken : ''); }} initOptions={{ onLoad: 'login-required', checkLoginIframe: false }}>
      <AppHeader toggleSideBar={() => { toggleSideBar(!isSideBarClosed) }} menu={true} keycloak={keycloak} />
      <SidebarLayout collapsed={isSideBarClosed} noIcons={true} className="app-sidebar">
        <SideBarApp isSideBarOpen={() => toggleSideBar(!isSideBarClosed)} isOpen={isSideBarClosed} />
        <SidebarLayout.Content>
          <KeyCloackAuth />
        </SidebarLayout.Content>
      </SidebarLayout>

    </ReactKeycloakProvider>
  )
}

export const keyCloakLogout = () => {
  return keycloak.logout();
}